import { SidebarItem } from 'types/ui'
import HomeIcon from '@mui/icons-material/Home'
import {
  DocumentScanner,
  EventNote,
  NotificationAdd,
  Search,
  Settings,
  VideoCameraBack,
  Dashboard,
  Group,
  Quiz,
  Summarize,
  Article,
  PeopleOutline,
} from '@mui/icons-material'
import { EOrganizationType, EUserRoles } from 'types/users'

export const sidebarItems: SidebarItem[] = [
  {
    textKey: 'dashboard',
    path: '/portal',
    icon: <HomeIcon color="secondary" fontSize="medium" />,
  },
  {
    textKey: 'management-dashboard',
    path: '/portal/management-dashboard',
    icon: <Dashboard color="secondary" fontSize="medium" />,
    roles: [EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'tender-search',
    path: '/portal/tender-search',
    icon: <Search color="secondary" fontSize="medium" />,
  },
  {
    textKey: 'tender-committee',
    path: '/portal/tender-committee',
    icon: <Group color="secondary" fontSize="medium" />,
    roles: [EUserRoles.COMMISSION_MEMBER, EUserRoles.SUPER_ADMIN],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'procurement-committee',
    path: '/portal/procurement-committee',
    icon: <PeopleOutline color="secondary" fontSize="medium" />,
    roles: [EUserRoles.COMMITTEE_MEMBER, EUserRoles.SUPER_ADMIN],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'procurement-plans',
    path: '/portal/procurement-plans',
    icon: <EventNote color="secondary" fontSize="medium" />,
    roles: [EUserRoles.PROCUREMENT_SPECIALIST, EUserRoles.SUPER_ADMIN],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'contracts',
    path: '/portal/contracts',
    icon: <DocumentScanner color="secondary" fontSize="medium" />,
  },
  {
    textKey: 'notifications',
    path: '/portal/notifications',
    icon: <NotificationAdd color="secondary" fontSize="medium" />,
  },
  {
    textKey: 'video-instruction',
    path: '/portal/video-instruction',
    icon: <VideoCameraBack color="secondary" fontSize="medium" />,
    roles: [
      EUserRoles.PROCUREMENT_SPECIALIST,
      EUserRoles.ADMIN,
      EUserRoles.SUPER_ADMIN,
    ],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'faq',
    path: '/portal/faq',
    icon: <Quiz color="secondary" fontSize="medium" />,
    roles: [
      EUserRoles.PROCUREMENT_SPECIALIST,
      EUserRoles.ADMIN,
      EUserRoles.SUPER_ADMIN,
    ],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'reports',
    path: '/portal/reports',
    icon: <Summarize color="secondary" fontSize="medium" />,
    roles: [
      EUserRoles.PROCUREMENT_SPECIALIST,
      EUserRoles.ADMIN,
      EUserRoles.SUPER_ADMIN,
    ],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'news',
    path: '/portal/news',
    icon: <Article color="secondary" fontSize="medium" />,
    roles: [
      EUserRoles.PROCUREMENT_SPECIALIST,
      EUserRoles.ADMIN,
      EUserRoles.SUPER_ADMIN,
    ],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'organizations',
    path: '/portal/organizations',
    icon: <Article color="secondary" fontSize="medium" />,
    roles: [EUserRoles.ADMIN, EUserRoles.SUPER_ADMIN],
    orgType: EOrganizationType.TENDER_AUTHORITY,
  },
  {
    textKey: 'settings',
    path: '/portal/settings',
    icon: <Settings color="secondary" fontSize="medium" />,
  },
]

export function getSidebarItems(
  userRoles: EUserRoles[],
  organizationType: EOrganizationType
) {
  return sidebarItems.filter((item) => {
    const hasRequiredRole =
      !item.roles || item.roles.some((role) => userRoles.includes(role))
    const hasRequiredOrgType = !item.orgType || item.orgType === organizationType
    return hasRequiredRole && hasRequiredOrgType
  })
}
